module.exports = "<div class=\"caja\" cdkDrag>\n  Drag me!\n</div>\n"